// deps
import React, { memo, useState, useEffect, useRef } from "react";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

// styles
import { CartPMMWidgetContainer, PMMBannerArrow, PMMBannerContainer, PMMBannerImage } from "./styles";

// Constants
import { CART_PMM_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

// Types
import { PMMWidgetProp } from "@swiggy-private/cart-types";

const CartPMMWidget = ({
    PMMBanner,
    isEditState,
    hideArrow = false,
    RxInstructionsTextAreaActive,
    targetRef,
    isBoltCart,
}: PMMWidgetProp & { targetRef?: React.RefObject<HTMLElement> }) => {
    const [error, setError] = useState(false);
    const arrowRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const showBanner = !isEmpty(PMMBanner) && !isEditState && !RxInstructionsTextAreaActive && !error;

    useEffect(() => {
        if (!targetRef?.current || !arrowRef.current || !containerRef.current) return;

        const pillRect = targetRef.current.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        const arrow = arrowRef.current;

        const offsetLeft = pillRect.left + pillRect.width / 2 - containerRect.left;

        arrow.style.left = `${offsetLeft}px`;
    }, [showBanner, targetRef, isBoltCart]);

    if (isEmpty(showBanner)) {
        return null;
    }

    return (
        <>
            <CartPMMWidgetContainer data-testid={CART_PMM_WIDGET_TEST_IDS.CART_PMM_WIDGET_CONTAINER} ref={containerRef}>
                <PMMBannerContainer data-testid={CART_PMM_WIDGET_TEST_IDS.PMM_BANNER_CONTAINER}>
                    <PMMBannerArrow
                        ref={arrowRef}
                        hideArrow={hideArrow}
                        arrowColor={PMMBanner?.arrowColor || ""}
                        data-testid={CART_PMM_WIDGET_TEST_IDS.PMM_BANNER_ARROW}
                    />
                    <PMMBannerImage
                        cloudinaryId={PMMBanner?.imageId || ""}
                        data-testid={CART_PMM_WIDGET_TEST_IDS.PMM_BANNER_IMAGE}
                        fit="contain"
                        onError={() => setError(true)}
                    />
                </PMMBannerContainer>
            </CartPMMWidgetContainer>
        </>
    );
};

export default memo(CartPMMWidget);
